import React from 'react'
import { BarChart, XAxis, YAxis, Grid } from 'react-native-svg-charts';
import { View, Text, StyleSheet, Dimensions, TouchableOpacity } from 'react-native';
import Theme from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';

export class TrackingBarGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showValues: false,
    }
  }

  onBarGraphPress = () => {
    this.setState({ showValues: !this.state.showValues });
  }


  render() {
    const yAxisData = [this.props.graphYAxis.min, this.props.graphYAxis.max];
    const contentInset = { left: defaultScale(20), right: defaultScale(20), bottom: defaultScale(13), top: defaultScale(5) };
    const axesSvg = { fontSize: scaleText(10), fill: Theme.GREY_DARK };

    const chartData = this.props.graphDataPoints.map((value: any, index: any) => {
      const ifNoValueForMonth = !value.y;
      const ifNotFirstValueInArray = index >= 1;
      const prevValueExists = ifNotFirstValueInArray && this.props.graphDataPoints[index - 1].y !== undefined;
      const usePreviousIndex = ifNoValueForMonth && ifNotFirstValueInArray && prevValueExists;
      return {
        value: ifNoValueForMonth ? usePreviousIndex ? this.props.graphDataPoints[index - 1].y : 0 : value.y,
        svg: {
          fill: value.y ? Theme.GREY_DARK_MEDIUM : Theme.GREY,
        }
      };
    });
    const CustomYAxis = ({ bandwidth, ...restProps }: any) => (
      <YAxis
        {...restProps}
        style={{ width: defaultScale(40), height: defaultScale(80) }}
        contentInset={contentInset}
        svg={axesSvg}
        yMin={this.props.graphYAxis.min}
        yScale={25}
        yMax={this.props.graphYAxis.max}
        data={yAxisData}
        yAccessor={({ item }) => item}
        formatLabel={(_, index) => _ + this.props.changeUnit}
        numberOfTicks={this.props.graphYAxis.ticks}
      />
    );
    return (
      <TouchableOpacity onPress={() => this.onBarGraphPress()}>
        <View style={styles.container}>
          {this.state.showValues &&
            <View style={[styles.barValuesContainer, {paddingTop: this.state.showValues ? defaultScale(10) : 0}]}>
              {chartData.map((data) => {
                return <Text style={styles.barValueText}>{!data.value ? 0 : data.value}</Text>
              })}
            </View>}
          <View
            style={[styles.barGraphContainer, {paddingTop: this.state.showValues ? 0 : defaultScale(10)}]}>
            <CustomYAxis />
            <BarChart
              style={{ flex: 1 }}
              data={chartData}
              yMin={this.props.graphYAxis.min}
              yMax={this.props.graphYAxis.max}
              contentInset={{ bottom: 0, top: defaultScale(5) }}
              svg={{ fill: '#58CC72' }}
              spacingOuter={0}
              yAccessor={({ item }: any) => item.value}
              numberOfTicks={this.props.graphYAxis.ticks}
            >
              <Grid direction={'HORIZONTAL'} svg={{ stroke: 'rgba(151, 151, 151, 0.27)' }} />
            </BarChart>
          </View>
          <View style={styles.xAxisContainer}>
            {this.props.graphDataPoints.map((data) => {
              return <Text style={styles.xAxisText}>{data.x}</Text>
            })}
          </View>
        </View>
      </TouchableOpacity>
    )
  }
}
const isSmallMobile = window.innerWidth <= 350;
const styles = StyleSheet.create({
  container: {
    flexDirection: 'column'
  },
  barValuesContainer: {
    flexDirection: 'row',
    marginLeft: defaultScale(43),
    justifyContent: 'space-between'
  },
  barValueText: {
    fontSize: scaleText(8),
    color: Theme.GREY_DARK,
  },
  barGraphContainer: {
    height: defaultScale(80),
    flexDirection: 'row',
  },
  xAxisContainer: {
    flexDirection: 'row',
    marginTop: defaultScale(8),
    marginLeft: defaultScale(38),
    marginBottom: defaultScale(10),
    justifyContent: 'space-between'
  },
  xAxisText: {
    fontSize: isSmallMobile ? scaleText(8) : scaleText(10),
    color: Theme.GREY_DARK
  }
});
